@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.batch-processing-modal {
  // less escape syntax
  // Prefer 600px height, but if the viewport is smaller than that, use 100vh - 60px
  // (60px is the top/bottom margin of the modal)
  min-height: e('min(600px, calc(100vh - 60px))');
  width: 850px;
  display: flex;
  flex-direction: column;
}

.batch-processing-modal-header {
  background-color: @label-batch-status-modal--header--background-color;
}

.batch-processing-modal-body {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
  padding: @space-16;
  flex-grow: 1;
  min-width: 850px;
  width: 100%;
  background-color: @label-batch-status-modal--body--background-color;
}

.batch-processing-modal-footer {
  height: 100%;
  > button {
    margin: 4px 0 0 10px;
  }
}

.batch-progress-loading-indicator {
  min-height: 420px;
}
